/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState, useRef } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { OTPInputComp } from './components';
import * as S from './styles';
// import "../styles.css";

export interface IOTPCompProps {
  fields?: any;
  submitButtonLabel?: string;
  onFormSubmit?(payload: any): void;
  renderSubmitButton?(): void;
  labelColor?: string;
  email?: string;
  phoneNumber?: string;
  onResendClick?(): void;
  counterVal?: number;
}

export const OTPComp = (props: IOTPCompProps) => {
  const {
    fields,
    email,
    phoneNumber,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
    onResendClick,
    counterVal,
  } = props;
  const [formData, updateFormData] = useState<any>({});
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [counter, setCounter] = useState(counterVal ?? 30);

  React.useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const _renderSubmitButton = () => {
    if (renderSubmitButton) {
      return renderSubmitButton();
    }
    return (
      <div className="mt-3">
        <Button
          variant="secondary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '50%',
            borderRadius: '0px',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {submitButtonLabel}
        </Button>
      </div>
    );
  };

  const handleSubmit = (e?: any) => {
    const form = e.currentTarget;
    const isValid = form.checkValidity();
    e.preventDefault();
    e.stopPropagation();
    let hasError = false;

    const errorsObj: any = {};
    if (fields?.phoneNumber?.required && !formData[fields?.phoneNumber?.id]) {
      errorsObj[fields.phoneNumber.id] = true;
      hasError = true;
    }
    if (
      fields?.otp?.required &&
      (!formData[fields?.otp?.id] || formData[fields?.otp?.id].length !== 6)
    ) {
      errorsObj[fields.otp.id] = true;
      hasError = true;
    }
    setValidated(true);
    if (!hasError && isValid) {
      setErrors({});
      onFormSubmit && onFormSubmit(formData);
    } else {
      window?.scrollTo(0, 0);
      setErrors(errorsObj);
    }
  };

  const _handleResendClick = () => {
    setCounter(30);
    if (onResendClick) {
      onResendClick();
    }
  };
  const handleCompChange = (id: string, payload: any) => {
    if (id && payload && errors[id]) {
      delete errors[id];
    }
    updateFormData({
      ...formData,
      [id]: payload,
    });
  };
  const _renderLayout = () => {
    return (
      <Row key={`layout-1-row-default-layout`}>
        <Col key={`layout-1-columns-email`} sm={12} className="mb-3">
          <OTPInputComp
            {...fields?.otp}
            email={email}
            phoneNumber={phoneNumber}
            onCompChange={handleCompChange}
            hasError={!!errors[fields.otp.id]}
          />
        </Col>
      </Row>
    );
  };
  return (
    <>
      <Form
        noValidate
        validated={validated}
        className="mt-4"
        onSubmit={handleSubmit}
      >
        <>
          {_renderLayout()}
          {/*{_renderFormGroup()}*/}
          {_renderSubmitButton()}
        </>
      </Form>
      <div>
        {counter > 0 ? (
          <S.TimerText>{`Did not receive the One-Time Password? resend in ${counter} seconds`}</S.TimerText>
        ) : (
          <S.ResendText
            onClick={_handleResendClick}
          >{`Resend One-Time Password`}</S.ResendText>
        )}
      </div>
    </>
  );
};

OTPComp.defaultProps = {
  counterVal: 30,
  fields: {
    otp: {
      id: 'otp',
      label: 'A One-Time Password has been sent to',
      required: true,
      errorText: 'One-Time Password is required',
    },
  },
};
